import type { FullCancellationSheetVariant } from '@/scopes/account/booking-details/pages/selectors/fullCancellationSelectors'
import { Button } from '@sunwebgroup/uds-ui/button'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import styles from './PartialCancellationSubmitResult.module.css'

interface FullCancellationErrorResultConfig {
  titleKey: string
  messageKey: string
}

const FULL_CANCELLATION_COSTS_FETCH_ERROR_CONFIG: FullCancellationErrorResultConfig = {
  titleKey: 'booking_details_cancel_booking_full_cancellation_error_title',
  messageKey: 'booking_details_cancel_booking_full_cancellation_error_message',
}

const FULL_CANCELLATION_SUBMIT_ERROR_CONFIG: Record<
  FullCancellationSheetVariant,
  FullCancellationErrorResultConfig
> = {
  'free': {
    titleKey: 'booking_details_cancel_booking_full_cancellation_submit_error_title',
    messageKey: 'booking_details_cancel_booking_full_cancellation_submit_error_message',
  },
  'with-cost': {
    titleKey: 'booking_details_cancel_booking_full_cancellation_with_cost_submit_error_title',
    messageKey: 'booking_details_cancel_booking_full_cancellation_with_cost_submit_error_message',
  },
}
interface FullCancellationErrorResultProps {
  variant?: FullCancellationSheetVariant
}

export function FullCancellationErrorResult({ variant }: FullCancellationErrorResultProps = {}) {
  const { formatMessage } = useIntl()
  const { cancelBookingDialogClosed } = useBookingDetailsActions()
  const config = variant
    ? FULL_CANCELLATION_SUBMIT_ERROR_CONFIG[variant]
    : FULL_CANCELLATION_COSTS_FETCH_ERROR_CONFIG

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Icon glyph="InformationInCircle" size={48} className={styles.iconError} />
        <Typography variant="body-m-bold-snug" as="h2">
          {formatMessage({ id: config.titleKey })}
        </Typography>
        <Typography variant="body-s-regular-snug" as="p">
          {formatMessage({ id: config.messageKey })}
        </Typography>
        <Button
          variant="primary"
          className={styles.closeButton}
          onClick={cancelBookingDialogClosed}
        >
          {formatMessage({ id: 'booking_details_cancel_booking_full_cancellation_confirm_button_label' })}
        </Button>
      </div>
    </div>
  )
}
